import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import axios from 'axios';
import { url } from '../../weburl';
import CountryContext from '../country_context';
import { BeatLoader } from 'react-spinners';
import Swal from 'sweetalert2';
export const SelectPriceTypeModal = (props) => {

    const context = useContext(CountryContext)
    const [phoneNumber, setPhoneNumber] = useState()
    const [modalResponse, setModalResponse] = useState()
    const [open, setOpen] = useState(props.open)
    const handleClose = () => {

    }

    const handleChange = (e) => {
        setPhoneNumber(e.target.value)
    }

    const supplyPhoneNumber = () => {
        axios
            .post(`${url}api/users/${context.user_sql_details.id}`, { phone_number: phoneNumber })
            .then((res) => {
                setModalResponse(res.data.message)
                console.log(res)
                setOpen(false)
                Swal.fire('Updated!', '', 'success')


            })
            .catch((err) => {
                console.log(err)
            })
    }
    return (

        <div>
            <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >

                <DialogContent dividers>
                    <div className="row align-items-center justify-content-center  ">

                        <div className=" col-md-12 px-4 my-2 mx-sm-0 text-center text-md-left">
                            <h3>{props.title}</h3>
                            <h5 className="mb-5 mt-2">Please select a type</h5>

                                <div className='d-flex flex-column'>
                                    <Link to={`/dog_registrations/${props.domesticPrice}`}>
                                        DOMESTIC: <span className='brand-yellow-font font-weight-bold' >{props.domesticPrice}</span>
                                    </Link>
                                    <Link to={`/dog_registrations/${props.internationalPrice}`
                               
                                }
                                className='mt-3'>  INTERNATIONAL
                                       <span className='brand-yellow-font font-weight-bold' > {props.internationalPrice}</span>
                                    </Link>
                                </div>

                        </div>
                    </div>
                </DialogContent>
                {/* <DialogActions>
                    <Button autoFocus onClick={supplyPhoneNumber}>
                        REGISTER
                    </Button>
                </DialogActions> */}
            </Dialog>



        </div>

    )
}